import { Controller } from "@hotwired/stimulus"
import { DateTime } from "luxon"

export default class extends Controller {
  static targets = ["startDate", "endDate", "submit"]

  connect() {
    this.validate()
  }

  validate() {
    if (!this.hasStartDateTarget || !this.hasEndDateTarget || !this.startDateTarget.value || !this.endDateTarget.value) {
      this.disableSubmit();
      return;
    }

    const startDate = DateTime.fromISO(this.startDateTarget.value);
    const endDate = DateTime.fromISO(this.endDateTarget.value);

    if (startDate >= endDate) {
      this.startDateTarget.setCustomValidity(window.I18n.notifications.start_date_must_be_before_end_date);
      this.endDateTarget.setCustomValidity(window.I18n.notifications.start_date_must_be_before_end_date);
      this.disableSubmit();
    } else {
      this.clearValidationErrors();
      this.enableSubmit();
    }

    this.startDateTarget.reportValidity();
    this.endDateTarget.reportValidity();
  }

  clearValidationErrors() {
    this.startDateTarget.setCustomValidity("")
    this.endDateTarget.setCustomValidity("")
  }

  disableSubmit() {
    this.submitTarget.disabled = true
  }

  enableSubmit() {
    this.submitTarget.disabled = false
  }
}
